module.exports = __webpack_public_path__ + "img/sh_260410_2.efafcc02.jpg";